(function () {
  const dataEl = document.getElementById('ps-data');
  if (!dataEl) return;

  const successorHandle = dataEl.dataset.successorHandle;
  if (!successorHandle) return;

  // 1. Nascondi pulsanti acquisto
  const style = document.createElement('style');
  style.textContent = `
    .btn.pr_btn.product-form__submit.btnzoom,
    button[name="add"],
    .shopify-payment-button,
    .shopify-payment-button__button {
      display: none !important;
    }
  `;
  document.head.appendChild(style);

  // 2. Crea il banner
  const banner = document.createElement('div');
  banner.id = 'ps-banner';
  banner.innerHTML = `
    <div style="
      background: #F6F4EF;
      border: 2px solid #7F9371;
      border-radius: 8px;
      padding: 16px 20px;
      margin: 16px 0 8px;
      font-size: 15px;
      line-height: 1.6;
      color: #333;
    ">
      <p style="margin: 0 0 14px;"><strong>Non perderlo!</strong> Questo modello non è più disponibile, ma abbiamo selezionato per te il suo naturale successore dalla nuova collezione. Stesso stile, qualità ancora più raffinata.</p>
      <a href="/products/${successorHandle}" style="
        display: inline-block;
        background: #7F9371;
        color: #fff;
        padding: 10px 22px;
        border-radius: 6px;
        text-decoration: none;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.5px;
      ">Scopri il sostituto →</a>
    </div>
  `;

  // 3. Inserisci dopo il titolo
  const titleEl = document.querySelector('.product-single__title');
  if (titleEl && titleEl.parentNode) {
    titleEl.parentNode.insertBefore(banner, titleEl.nextSibling);
  } else {
    const form = document.querySelector('form[action="/cart/add"]');
    if (form) form.parentNode.insertBefore(banner, form);
  }
})();
